export default __webpack_public_path__ + "static/media/bg_img.38f89ad7.jpg";